import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';

import './styles/app.css';
import './styles/agent-workspace.css';

// The PWA service worker (public/sw.js) is deliberately network-only: it
// enables standalone installation without ever caching app or Supabase data,
// so nothing stale can be served and no offline conflicts are possible.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* Registration is a progressive enhancement; the app runs without it. */
    });
  });
}

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);